<template>
  <section id="app">
    <nprogress-container></nprogress-container>
    <aside :class="large ? 'large': ''">
      <heim-side :large="large"></heim-side>
    </aside>
    <main :class="large ? 'large': ''">
      <header>
        <heim-mobile></heim-mobile>
        <heim-nav></heim-nav>
      </header>
      <router-view/>
      <heim-toast duration="1000">
        <heim-button @click.native="closeToast">{{ $t("close") }}</heim-button>
      </heim-toast>
    </main>
    <heim-iconset></heim-iconset>
  </section>
</template>
<script>
import HeimNav from "@/components/layout/ui/heim-nav";
import HeimSide from "@/components/layout/ui/heim-side";
import HeimMobile from "@/components/layout/ui/heim-mobile";
import HeimIconset from "@/components/icon/heim-iconset";
import HeimToast from "@/components/message/heim-toast.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
import { mapState } from "vuex";
export default {
  name: "app",
  components: {
    HeimNav,
    HeimSide,
    HeimIconset,
    HeimToast,
    HeimButton,
    HeimMobile,
    NprogressContainer
  },
  computed: mapState(["large", "token"]),
  methods: {
    closeToast() {
      this.$store.dispatch("setOpenToast", { opened: false });
      this.$store.dispatch("clearToastTimout");
    }
  },
  watch: {
    token(token) {
      if (!token) this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.logo-large {
  display: none;
}
#app {
  display: flex;
  flex-wrap: nowrap;
}
header {
  position: sticky;
  height: 3.25rem;
  z-index: 30;
}
header {
  height: initial;
}
aside {
  position: fixed;
  overflow: hidden;
  top: 0;
  height: 100vh;
  min-width: 4.3rem;
  width: 60vw;
  background-color: #ffffff;
  z-index: 40;
  box-shadow: 0 0.125rem 9.375rem rgba(90, 97, 105, 0.1),
    0 0.25rem 0.5rem rgba(90, 97, 105, 0.12),
    0 0.9375rem 1.375rem rgba(90, 97, 105, 0.1),
    0 0.4375rem 2.1875rem rgba(165, 182, 201, 0.1);
  transition: width 0.3s ease, transform 0.3s ease;
  transform: translateX(-100vw);
}
main {
  margin-left: auto;
  width: 100%;
  transition: margin-left 0.3s ease;
}

/* Wide layout: when the viewport width is bigger than 460px, layout
changes to a wide layout. */
@media (min-width: 460px) {
  /* Sidebar behaviour */
  aside {
    width: 4.3rem;
    transform: translateX(0) !important;
  }
  main {
    margin-left: 4.3rem;
    margin-bottom: 2em;
  }
  aside.large {
    width: 12rem;
  }
  main.large {
    margin-left: 12rem;
  }
  header {
    height: 3.25rem;
  }
}
</style>
<style>
:root {
  --heim-primary-color: #263238;
  --heim-secondary-color: #148da0;
  --heim-text-color: #363636;
  --heim-white-color: #ffffff;
  --heim-grey-color: #f8f9fd;
  --heim-red-color: #f84242;

  --heim-green-bgcolor: #d8f5ea;
  --heim-darkgreen-color: #265d49;
  --heim-red-bgcolor: #ffe0e0;
  --heim-darkred-color: #6f2323;
  --heim-orange-bgcolor: #f9edc7;
  --heim-darkorange-color: #63321c;

  --heim-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  --heim-shadow-hight: 0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
  --heim-transition: cubic-bezier(0.25, 0.8, 0.25, 1);
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
/* CSS reset */
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
a {
  color: var(--heim-secondary-color);
  cursor: pointer;
  text-decoration: none;
}
.paper-action {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--heim-secondary-color);
  border: none;
  padding: 0 0.8rem;
  border-radius: 30px;
  min-width: 6em;
  border: solid 2px var(--heim-secondary-color);
  font-weight: 600;
  font-size: 0.9em;
  cursor: pointer;
  outline: none;
  text-transform: capitalize;
  transition: box-shadow 0.3s ease;
}
.paper-action:hover,
.paper-action:focus {
  box-shadow: var(--heim-shadow);
}
.paper-action .icon {
  border-radius: 50%;
}
/* Cancel button modal */
.cost-cancel { margin-right: 1rem; font-weight: 600; }

.label {
  font-weight: 600;
}

.ctn {
  padding: 8px 16px;
  margin: 1em 0;
}
.ctn header.header {
  padding: 1rem 0.625rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.ctn header.header.left {
  justify-content: space-between;
}
.paper-card {
  background-color: white;
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
  border-radius: 3px;
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1);
}
.badge {
  background-color: var(--heim-white-color);
  padding: 0.2rem 0.8rem;
  border-radius: 30px;
  min-width: 5rem;
  text-align: center;
  font-weight: 600;
  cursor: default;
}
.green {
  background-color: var(--heim-green-bgcolor);
  color: var(--heim-darkgreen-color);
}
.red {
  background-color: var(--heim-red-bgcolor);
  color: var(--heim-darkred-color);
}
.orange {
  background-color: var(--heim-orange-bgcolor);
  color: var(--heim-darkgreen-color);
}
/* Les animations d'entrée (« enter ») et de sortie (« leave »)  */
/* peuvent utiliser différentes fonctions de durée et de temps.  */
.slide-fade-enter-active {
  transition: all 0.3s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-3px);
  opacity: 0;
}

.vdp-datepicker__calendar .cell.selected,
.vdp-datepicker__calendar .cell:hover {
  background: var(--heim-secondary-color);
  color: #fff;
}

.help {
  padding: 5px 10px;
  font-size: 13px;
  margin: 10px 0;
  display: inline-flex;
  border-radius: 3px;
  align-items: center;
}

.is-danger {
  color: #d8000c;
  background-color: #ffd2d2;
}

/* Wide layout: when the viewport width is bigger than 768px, layout
changes to a wide layout. */
@media (min-width: 769px) {
  .ctn {
    margin: 1em 5em 0 5em;
  }
}

@media screen and (max-width: 1024px) {
  body table td.tab-noShow,
  body table th.tab-noShow {
    display: none;
  }

  body table td.tab-show,
  body table th.tab-show {
    display: block ;
  }
}
</style>
